export const getXmlElement = (source, tagName, index) => {
  const element = source.getElementsByTagName(tagName);
  if (element && element.length >= index && element[index]) {
    return element[index];
  }
  return {};
};
